import script from "./AddAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAsset.vue?vue&type=script&setup=true&lang=js"

import "./AddAsset.vue?vue&type=style&index=0&id=0ea49658&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea49658"]])

export default __exports__